import { render } from "./vueFooter.vue?vue&type=template&id=7dc4987c&scoped=true"
import script from "./vueFooter.vue?vue&type=script&lang=js"
export * from "./vueFooter.vue?vue&type=script&lang=js"

import "./vueFooter.vue?vue&type=style&index=0&id=7dc4987c&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc4987c"]])

export default __exports__